// extracted by mini-css-extract-plugin
module.exports = {"spanning":"MessagesComp_spanning__2V_B5"};